import { createStore } from 'vuex'
import {version, name} from './../../package.json'

import authModule from './modules/auth/index.js';
import usersModule from './modules/users/index.js';
import seasonsModule from './modules/seasons/index.js';
import schedulesModule from './modules/schedules/index.js';
import teamsModule from './modules/teams/index.js';
import picksModule from './modules/picks/index.js';

export default createStore({
  state () {
    return {
      appVersion: version || 'unknown',
      appName: name || 'unknown',
      productionState: process.env.NODE_ENV || 'unknown',
      debugMode: false,
      backgroundColor: '#002244', // navy
      // backgroundColor: 'blue',
      foregroundColor: '#FB4F14', // orange
      // foregroundColor: 'yellow',
      snackbar: {
        showSnackbar: false,
        color: 'grey',
        timeout: 0,
        buttonText: "Close",
        message: "",
      }
    }
  },
  getters: {
    appVersion(state) {
      return state.appVersion;
    },
    appName(state) {
      return state.appName;
    },
    productionState(state) {
      return state.productionState;
    },
    debugMode(state) {
      return state.debugMode;
    },
    backgroundColor(state) {
      return state.backgroundColor;
    },
    foregroundColor(state) {
      return state.foregroundColor;
    },
    snackbar(state) {
      return state.snackbar;
    }
  },
  mutations: {
    setSnackbar(state, snackbar) {
      Object.assign(state.snackbar, snackbar);
    },
  },
  actions: {
    async loadData(context) {
      console.group("loadData");

      console.info("dispatching loadSeasons");
      await context.dispatch("seasons/loadSeasons")
  
      console.info("dispatching loadSchedules");
      await context.dispatch("schedules/loadSchedules");

      // console.info("dispatching setCurrentSchedule");
      // await context.dispatch("schedules/setCurrentSchedule");
  
      console.info("dispatching setCurrentTeamslist");
      await context.dispatch("teams/setCurrentTeamsList");
  
      console.info("dispatching loadAllUsers");
      await context.dispatch("loadAllUsers");
  
      console.info("dispatching loadAllPicks");
      await context.dispatch("picks/loadAllPicks");

      if ( context.getters.debugMode ) {
        // { seasonId: "s1", weekNumber: ++weekNumber, gameId: gameId++, visitor: "Dallas Cowboys", home: "Tampa Bay Buccaneers", points: pointsPerWeek[weekNumber-1], winner: null },
  
        var schedule = context.getters["schedules/currentSchedule"];
        for ( var game = 0; game < 272; game++ ) {
          schedule[game].winner = schedule[game].home;
          if ( (game+1) % 12 === 0 ) {
            schedule[game].winner = "TIE"
          }
        }
  
        console.info("currentSchedule (partial fill)")
        console.table(context.getters["schedules/currentSchedule"]);
      } else {
        console.info("not debugMode");
      }
  
      console.groupEnd();
    },
    async loadRestrictedData(context) {
      console.group("loadRestrictedData");

      const userId = context.rootGetters.userId;
  
      // await context.dispatch("setCurrentUser", userId, { root: true });  
      await context.dispatch("setCurrentUser", userId);  

      console.groupEnd();
    }
  },
  modules: {
    auth: authModule,
    users: usersModule,
    seasons: seasonsModule,
    schedules: schedulesModule,
    teams: teamsModule,
    picks: picksModule,
  }
})
